export default __webpack_public_path__ + "static/media/logo.0055d80a.svg";